module.exports = __webpack_public_path__ + "static/media/new_sharebot.08d8468c.svg";